<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper login-body">
    <div class="login-wrapper">
      <div class="container">
        <img
          class="img-fluid logo-dark mb-2"
          :src="invoice?.user?.setting?.business_logo"
          alt="Logo"
        />
        <div class="loginbox">
          <div class="login-right">
            <div class="login-right-wrap">
              <h1>Make Payment</h1>
              <p class="account-subtitle">Make Payment for your Invoice.</p>

              <form @submit.prevent="makePayment" class="modal-body">
                <div class="form-header">
                  <div
                    class="form-group text-start mt-2"
                    v-if="invoice?.currency === 'USD'"
                  >
                    <label for="currencyLabel">Gateway</label>

                    <b-form-select
                      class="form-select"
                      v-model="payment_form.gateway"
                      required
                    >
                      <b-form-select-option selected value=""
                        >Please select</b-form-select-option
                      >
                      <b-form-select-option
                        v-for="(gateway, index) in allGateway"
                        :key="index"
                        :value="gateway.value"
                      >
                        {{ gateway.name }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                  <div class="form-group text-start mt-2">
                    <label>Amount</label>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <span style="font-size: 12px">{{
                          invoice.currency
                        }}</span>
                      </b-input-group-prepend>
                      <b-form-input
                        type="number"
                        v-model="payment_form.amount"
                        class="form-control"
                        :max="invoice.amount_due"
                        min="1"
                        placeholder="Enter the Amount"
                        required
                      />
                    </b-input-group>
                  </div>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <button
                        type="submit"
                        class="w-100 btn btn-primary"
                        :disabled="isLoading"
                      >
                        <span
                          v-if="isLoading"
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span v-if="!isLoading">Make Payment</span>
                        <span v-if="isLoading">Processing...</span>
                      </button>
                    </div>
                    <div class="col-6">
                      <button
                        type="submit"
                        @click="closePayment"
                        class="w-100 btn btn-primary paid-cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });

const store = useStore();
const route = useRoute();
const router = useRouter();
const isLoading = ref(false);

const allGateway = [
  { name: "Stripe", value: "stripe" },
  { name: "Paypal", value: "paypal" },
];

const payment_form = ref({
  invoice_id: "",
  amount: "",
  wallet: true,
  gateway: "",
});

const closePayment = () => {
  router.push({ name: "login" });
};

const paymentlink = computed(() => {
  return store.getters["invoices/paystacklink"];
});

const makePayment = async () => {
  isLoading.value = true;
  if (invoice.value.currency === "NGN") {
    payment_form.value.gateway = "paystack";
  }
  await store
    .dispatch("invoices/makePayment", payment_form.value)
    .then(() => {
      isLoading.value = false;
    })
    .then(() => {
      if (paymentlink.value !== null) {
        window.location.href = paymentlink.value;
      }
    })
    .catch(() => {
      isLoading.value = false;
    });
};

const invoice = computed(() => {
  return store.getters["invoices/customer_invoice"];
});

const getCustomerInvoice = async () => {
  let data = {
    code: route.params.id,
    notify: false,
  };
  await store.dispatch("invoices/getCustomerInvoice", data).then(() => {
    payment_form.value.invoice_id = invoice.value.id;
    payment_form.value.amount = invoice.value.amount_due;
  });
};

onMounted(() => {
  getCustomerInvoice();
});
</script>
